.card_container {
  width: 15vw;
  height: 70vh;
  min-width: 25rem;
  min-height: 20rem;
  min-width: 25rem;
  max-height: 30rem;
  max-width: 6em;
  overflow: auto;
  overflow-y: visible;
}

.centered {
  display: flex;
  justify-content: center;
}

.padding_top {
  padding-top: 10px;
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo_image {
  width: 100px;
  height: 100px;
}

.small_logo {
  display: none;
  width: 30px; // Adjust the size as needed for the small logo
  height: 30px; // Adjust the size as needed for the small logo
  margin-right: 10px; // Space between the small logo and the title
}

.error_message {
  color: red;
}

.oidc_login_button {
  margin-top: 25px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.redirect_arrow {
  font-size: 1.2em;
  margin-right: 10px;
  margin-left: -7px;
}

/* Add a media query for small heights */
@media (max-height: 790px) {
  /* Adjust the value as needed */
  .logo_image {
    display: none;
  }
}

/* Add a media query for small heights */
@media (max-height: 790px) {
  /* Adjust the value as needed */
  .small_logo {
    display: flex;
  }
}
